import { render, staticRenderFns } from "./pedidoMobile.vue?vue&type=template&id=12578c00&scoped=true"
import script from "./pedidoMobile.vue?vue&type=script&lang=js"
export * from "./pedidoMobile.vue?vue&type=script&lang=js"
import style0 from "./pedidoMobile.vue?vue&type=style&index=0&id=12578c00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12578c00",
  null
  
)

export default component.exports